import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const Doctor: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <g clipPath="url(#clip0_507_458)">
                <IconPath
                    d="M7.4202 3.33C8.23369 4.1744 9.20913 4.84606 10.2882 5.30483C11.3672 5.76359 12.5277 6.00003 13.7002 6C14.8862 5.99743 16.0595 5.75596 17.1502 5.29M2.2002 23.25C2.2002 20.6641 3.22742 18.1842 5.0559 16.3557C6.88438 14.5272 9.36433 13.5 11.9502 13.5C14.5361 13.5 17.016 14.5272 18.8445 16.3557C20.673 18.1842 21.7002 20.6641 21.7002 23.25M12.7002 23.25V13.53M6.7002 18.75H9.70019M8.2002 17.25V20.25M6.7002 6C6.7002 6.68944 6.83599 7.37213 7.09983 8.00909C7.36366 8.64605 7.75038 9.2248 8.23788 9.71231C8.72539 10.1998 9.30415 10.5865 9.94111 10.8504C10.5781 11.1142 11.2608 11.25 11.9502 11.25C12.6396 11.25 13.3223 11.1142 13.9593 10.8504C14.5962 10.5865 15.175 10.1998 15.6625 9.71231C16.15 9.2248 16.5367 8.64605 16.8006 8.00909C17.0644 7.37213 17.2002 6.68944 17.2002 6C17.2002 5.31056 17.0644 4.62787 16.8006 3.99091C16.5367 3.35395 16.15 2.7752 15.6625 2.28769C15.175 1.80018 14.5962 1.41347 13.9593 1.14963C13.3223 0.885795 12.6396 0.75 11.9502 0.75C11.2608 0.75 10.5781 0.885795 9.94111 1.14963C9.30415 1.41347 8.72539 1.80018 8.23788 2.28769C7.75038 2.7752 7.36366 3.35395 7.09983 3.99091C6.83599 4.62787 6.7002 5.31056 6.7002 6Z"
                    {...pathProps}
                />
            </g>
            <defs>
                <clipPath id="clip0_507_458">
                    <rect width="24" height="24" fill="transparent" />
                </clipPath>
            </defs>
        </IconSVG>
    );
};
